/* eslint-disable react/jsx-props-no-spreading */
import { CSSProperties, PropsWithChildren } from 'react';

import { FieldByType } from 'components';

import { TEditableColumn, TFieldProps } from 'types';

interface ICRUDTableCellProps<T> extends Pick<TEditableColumn<T>, 'getStyles' | 'field'> {
  style?: CSSProperties;
  record: T;
  dataIndex: string;
  isFieldEditing: boolean;
}

export const CRUDTableCell = <T extends Record<string, unknown>, >({
  field,
  style,
  record,
  children,
  dataIndex,
  isFieldEditing,
  getStyles,
  ...rest
}: PropsWithChildren<ICRUDTableCellProps<T>>) => {
  const styles = { ...getStyles?.(record), ...style };

  if (isFieldEditing && field) {
    return (
      <td
        {...rest}
        style={styles}
      >
        <FieldByType
          field={{
            ...field as TFieldProps,
            name: dataIndex,
            itemClassName: 'mb-0',
          }}
        />
      </td>
    );
  }

  return (
    <td
      {...rest}
      style={styles}
    >
      {children}
    </td>
  );
};
